import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { URLS } from '../../resources/constants';
import { useUserSteps } from '../../resources/hooks/userStepsHook';

const UserStpesCheck = () => {
    const userSetpsChesk = useUserSteps();
    const location = useLocation();

    return(
        URLS.BUDGET == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> : 
        URLS.BANK_TRANSACTION == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.USERPROFILE == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.SETTINGS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.TAX_1099_PAYER_SETTINGS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BALANCESHEET == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.CHARTACCOUNT == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BANK_FEED == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.SALES_TRANSACTION == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.VIEW_REGISTER == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.PROFITLOSS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.FOURTHREETHREEB == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.PERSONAL_BALANCE_SHEET == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.PERSONAL_INCOME_STATMENT == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.OPENNING_BALANCE == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.STATEMENT_OF_CASH_FLOW == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BANK_RECONCILE == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BANK_RECONCILE_TRANSACTIONS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BUSINESS_RATIO == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.SALES == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.QBO_VENDORS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.QBO_CUSTOMERS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.BUDGET_VS_ACTUAL == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.TAX_RESOLUTION_FORMS == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        URLS.TAX_FORM_433B == location['pathname'] && userSetpsChesk >= 3 ? <Outlet/> :
        <Navigate to={URLS.DASHBOARD} />
    )
}

export default UserStpesCheck
